class KontaktForm {
    #$wrapper;
    #$form;

    constructor($wrapper) {
        this.#$wrapper = $wrapper;
        this.#$form = $wrapper.find('form');
        this.#$form.on('submit', this.handleFormSubmit.bind(this));
    }

    handleFormSubmit(e) {
        e.preventDefault();
        $.post(this.#$form.attr('action'), this.#$form.serialize()).done(this.submitSuccess.bind(this))
    }

    submitSuccess(data) {
        if (data) {
            this.#$form.hide();
            this.#$wrapper.html('<h2>' + data + '</h2>')
        }
    }
}

export default KontaktForm;